import { HttpClient, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable, OnDestroy } from '@angular/core';
import { throwError, of, Subject, BehaviorSubject, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../auth/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageTranslateService implements OnDestroy {
  public words: any;

  private _wordSource = new BehaviorSubject<any>({});
  wordSrc$ = this._wordSource.asObservable();
  
  private _menuSource = new BehaviorSubject<any>({});
  menuSrc$ = this._menuSource.asObservable();

  public refreshList$: EventEmitter<any>;
  private selectSubject = new Subject<void>();

  constructor(
    private http: HttpClient,
    private auth: AuthenticationService
  ) {
    this.refreshList$ = new EventEmitter();
  }

  ngOnDestroy(): void {
    // Complete any observables that need manual cleanup
    this.selectSubject.complete();
    this._menuSource.complete();
    this._wordSource.complete();
  }

  /**
   * Update all words
   * @param words - The words/translations object
   */
  updateWords(words: any): void {
    console.log("words", words);
    this.words = words;
    this._wordSource.next(words);
  }

  /**
   * Update all words for menu
   * @param menu - The menu translations object
   */
  updateMenu(menu: any): void {
    this._menuSource.next(menu);
  }

  /**
   * Complete all subjects (useful for cleanup)
   */
  completeSubjects(): void {
    this.selectSubject.complete();
    this._menuSource.complete();
    this._wordSource.complete();
  }

  /******************************************** Get Language Based on Selected Lang ******************************************/
  /**
   * Fetch translations for a specific language
   * @param language - Language code (e.g., 'en', 'my', 'zh')
   * @returns Observable with translation data
   */
  public getTranslateByLanguage(language: string): Observable<any> {
    return this.http.get( `${environment.base_url}/mongo/dynamic-label-setup/${language}/setup?source=WEB`, 
      { observe: 'response' }
    ).pipe(
      map((resp: any) => resp),
      catchError(error => {
        console.error('Get Translate by Language Error:', error);
        return throwError(() => error);
      })
    );
  }

  /******************************************** Save Language Data ******************************************/
  /**
   * Save translation data for a specific language and module
   * @param body - Translation data to save
   * @param module - Module name
   * @param language - Language code
   * @returns Observable with save result
   */
  public saveLanguage(body: any, module: string, language: string): Observable<any> {
    return this.http.post(
      `${environment.base_url}/mongo/dynamic-label-setup/${language}/setup?source=WEB&module=${module}`, 
      body, 
      { observe: 'response' }
    ).pipe(
      map((resp: any) => resp),
      catchError(error => {
        console.error('Save Language Error:', error);
        return throwError(() => error);
      })
    );
  }

  /**
   * Get nested value from object using dot notation path
   * @param obj - Source object
   * @param path - Dot-separated path (e.g., 'login.messages.error')
   * @returns The nested value or undefined
   * 
   * @example
   * const data = { login: { messages: { error: 'Invalid credentials' } } };
   * getNestedValue(data, 'login.messages.error'); // Returns: 'Invalid credentials'
   */
  public getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  }
}